<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Header({
              text: 'Kafle'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    required: true,
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'title'],
                    multilingual: true
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'image']
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
